import React from 'react';

import { cn } from 'utils/classNames';

import LoadingSpinner, { type CircleSize } from './LoadingSpinner';

interface Props {
	className?: string;
	size?: CircleSize;
}

export default function BlockLoadingSpinner({ className, size }: Props) {
	return (
		<LoadingSpinner
			variant="dashing"
			spinnerColor="julaRed"
			trackColor="transparent"
			className={cn('mx-auto my-8', className)}
			size={size}
		/>
	);
}
BlockLoadingSpinner.displayName = 'BlockLoadingSpinner';
